/** Platform-wide product name (fallback when no tenant is selected). */
export const APP_NAME = 'Sindikalni spletni portal';

function normalizeLabel(value) {
  const trimmed = String(value || '').trim();
  return trimmed || null;
}

function labelsDiffer(a, b) {
  return a.toLowerCase() !== b.toLowerCase();
}

/**
 * Browser tab title for the active tenant.
 * @param {{ branding?: { appTitle?: string }, displayName?: string } | null | undefined} config
 */
export function resolveDocumentTitle(config) {
  const appTitle = normalizeLabel(config?.branding?.appTitle);
  const displayName = normalizeLabel(config?.displayName);

  if (appTitle && displayName && labelsDiffer(appTitle, displayName)) {
    return `${appTitle} · ${displayName}`;
  }
  if (appTitle) return appTitle;
  if (displayName) return displayName;
  return APP_NAME;
}

/**
 * Footer copyright line for the active tenant.
 * @param {{ footer?: { copyright?: string }, displayName?: string } | null | undefined} config
 */
export function resolveFooterCopyright(config) {
  return normalizeLabel(config?.footer?.copyright)
    || normalizeLabel(config?.displayName)
    || APP_NAME;
}

/**
 * Legal/footer links configured per tenant.
 * @param {{ footer?: { links?: Array<{ label?: string, href?: string }> } } | null | undefined} config
 */
export function resolveFooterLinks(config) {
  if (!Array.isArray(config?.footer?.links)) {
    return [];
  }

  return config.footer.links.filter(
    (link) => normalizeLabel(link?.label) && normalizeLabel(link?.href),
  );
}

/**
 * Meta description for the active tenant.
 * @param {{ branding?: { appTitle?: string }, displayName?: string } | null | undefined} config
 */
export function resolveMetaDescription(config) {
  const displayName = normalizeLabel(config?.displayName);
  if (displayName) {
    return `${displayName} · ${APP_NAME}`;
  }
  return APP_NAME;
}
